import { createListViewContainer } from 'factories/ListView'
import selectors from 'selectors'
import actions from 'actions/reports/itemHistoryReport'
import Component from 'components/Reports/ItemHistoryReport'

export default createListViewContainer({ actions, selectors: selectors.itemHistoryReport })(Component)
